/* eslint-disable no-useless-catch */

import {
  REACT_APP_API_BASE_URL_LOGIN,
  REACT_APP_APPLICATION_CODE,
} from "constants/index";

import axios from "axios";
import storage from "utils/storage";

export const getUser = async (): Promise<any | null> => {
  try {
    return await axios.get(`/auth/me`, {
      headers: {
        Authorization: `Bearer ${storage.getToken()}`,
      },
      baseURL: REACT_APP_API_BASE_URL_LOGIN,
    });
  } catch (error) {
    throw error;
  }
};

export const getUserInfo = async (): Promise<any | null> => {
  try {
    return await axios.get(`/auth/userinfo`, {
      headers: {
        Authorization: `Bearer ${storage.getToken()}`,
        "x-application-code": REACT_APP_APPLICATION_CODE,
      },
      baseURL: REACT_APP_API_BASE_URL_LOGIN,
    });
  } catch (error) {
    throw error;
  }
};
